<template>
  <b-form>
    <b-card class="mb-3">
      <b-card class="mb-3">
        <loading v-if="databaseLoading" />
        <error-messages
          v-else-if="!databaseLoading && databaseErrorMessages.length > 0"
          :show="true"
          :message="databaseErrorMessages"
        />
        <b-card-group v-else deck class="card-deck-app">
          <card-app
            v-for="db in databaseList"
            :key="db.id"
            :selected="db.selected"
            :id="db.id"
            :title="db.name"
            :srcImage="db.picture"
            @click="selectDbClicked"
          />
        </b-card-group>
      </b-card>
      <b-card
        class="mb-3"
        v-if="
          databaseSelectedItem &&
            databaseSelectedItem.versions &&
            databaseSelectedItem.versions.length > 0
        "
      >
        <template #header>
          <h4 class="m-0">
            نسخه دیتابیس
          </h4>
        </template>
        <main-text>
          در زیر می‌توانید نسخه دیتابیس خود را انتخاب کنید.
        </main-text>
        <b-form-radio-group
          :checked="databaseSelectedVersion"
          :options="databaseSelectedItem.versions"
          value-field="id"
          text-field="version"
          @input="databaseSelectedVersionChanged"
        />
      </b-card>
      <b-card class="mb-3">
        <template #header>
          <h4 class="m-0">
            ساخت پلن
          </h4>
        </template>
        <main-text>
          منابع مورد نظر خود را انتخاب کنید
          <span class="text-danger">
            (دقت داشته باشید که امکان تغییر فضا پس از ایجاد برنامه نیست)
          </span>
          .
        </main-text>
        <resource />
      </b-card>
      <b-card class="mb-3">
        <template #header>
          <h4 class="m-0">
            پشتیبان‌گیری خودکار
          </h4>
        </template>
        <b-form-group class="m-0">
          <b-form-radio-group
            v-model="backupType"
            :options="backupOptions"
            @change="backupChangeHandler"
          ></b-form-radio-group>
        </b-form-group>
      </b-card>
      <h3 class="text-center text-success">هزینه کل: {{ mainPrice }} ریال</h3>
    </b-card>
    <b-form-group>
      <b-button
        variant="primary"
        @click="showCreateModal"
        :disabled="!stepCompelete"
      >
        ایجاد دیتابیس
      </b-button>
    </b-form-group>
    <create-database-modal
      :backupType="backupType"
      :visible="visibleCreateModal"
      @hidden="hiddenCreateModal"
      @show="showCreateModal"
    />
  </b-form>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import {
  SET_DATABASE_LIST,
  SELECT_DATABASE,
  SET_TYPE_SERVICE,
  BLUR_INPUT_SERVICE_NAME,
  SET_DEFAULT_STATE_SERVICE,
  SET_DATABASE_SELECTED_VERSION,
  UPDATE_SERVICE_NAME,
  TOTAL_PRICE_NUM
} from "@/store/mutation-types";
import MainText from "@/components/MainText/MainText.vue";
import Loading from "@/components/Loading/Loading.vue";
import ErrorMessages from "@/components/ErrorMessages/ErrorMessages.vue";
import Resource from "@/components/Resource/Resource.vue";
import CardApp from "@/components/CardApp/CardApp.vue";
import CreateDatabaseModal from "./CreateDatabaseModal.vue";
import { numberSpliter } from "@/utils/functions";

export default {
  name: "DatabaseCreateStepOne",
  components: {
    MainText,
    CardApp,
    Loading,
    ErrorMessages,
    Resource,
    CreateDatabaseModal
  },
  data() {
    return {
      stepCompelete: false,
      blurInputService: true,
      backupOptions: [
        { text: "نیاز ندارم", value: 1 },
        { text: "پشتیبان‌گیری روزانه", value: 2 },
        { text: "پشتیبان‌گیری هفتگی", value: 3 },
        { text: "پشتیبان‌گیری ماهانه", value: 4 }
      ],
      backupType: 1,
      backupPrice: 0,
      //create modal data
      visibleCreateModal: false
    };
  },
  computed: {
    mainPrice: function() {
      return numberSpliter(this[TOTAL_PRICE_NUM] + this.backupPrice);
    },
    ...mapGetters("resource", [TOTAL_PRICE_NUM]),
    ...mapState("resource", ["storage"]),
    ...mapState("service", [
      "databaseList",
      "databaseLoading",
      "databaseErrorMessages",
      "databaseSelectedItem",
      "databaseSelectedVersion",
      "serviceName",
      "validServiceName",
      "duplicateServiceName"
    ])
  },
  methods: {
    ...mapActions("service", [
      SET_DATABASE_LIST,
      SELECT_DATABASE,
      UPDATE_SERVICE_NAME,
      BLUR_INPUT_SERVICE_NAME,
      SET_TYPE_SERVICE,
      SET_DATABASE_SELECTED_VERSION,
      SET_DEFAULT_STATE_SERVICE
    ]),
    backupChangeHandler: function(val) {
      let totalPrice = this.storage.value * this.storage.pricePerUnit;
      switch (val) {
        case 1:
          this.backupPrice = totalPrice * 0;
          break;
        case 2:
          this.backupPrice = totalPrice * 4;
          break;
        case 3:
          this.backupPrice = totalPrice * 3;
          break;
        case 4:
          this.backupPrice = totalPrice * 2;
          break;
      }
    },
    selectDbClicked: function(id) {
      this[SELECT_DATABASE](id);
    },
    databaseSelectedVersionChanged: function(val) {
      this[SET_DATABASE_SELECTED_VERSION](val);
    },
    // create modal method
    showCreateModal: function() {
      this.visibleCreateModal = true;
    },
    hiddenCreateModal: function() {
      document.getElementById("scroll-area").scrollTo(0, 0);
      this.visibleCreateModal = false;
    }
  },
  mounted() {
    this[SET_DEFAULT_STATE_SERVICE]();
    this[SET_DATABASE_LIST]();
    this[SET_TYPE_SERVICE]("database");
  },
  updated() {
    if (this.databaseSelectedVersion !== "") {
      this.stepCompelete = true;
    } else {
      this.stepCompelete = false;
    }
  }
};
</script>
